import React, { useState } from 'react';
import { PrimaryButton } from '../../../components';
import css from './SectionContact.module.css';

function SectionContact() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = event => {
    event.preventDefault();
    // TODO: wire this form to backend/email workflow.
    setSubmitted(true);
  };

  return (
    <section className={css.contactSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <h2>Let’s Get In Touch</h2>
          <p>Questions, partnerships, or event ideas? Send us a note and we’ll reply soon.</p>
        </div>

        <form className={css.contactForm} onSubmit={handleSubmit}>
          <div className={css.formRow}>
            <input type="text" name="name" placeholder="Full name" required />
            <input type="email" name="email" placeholder="Email address" required />
          </div>
          <textarea name="message" placeholder="How can we help?" rows="4" required />
          <PrimaryButton type="submit">Send Message</PrimaryButton>
          {submitted ? <span className={css.confirmation}>Thanks! We’ll be in touch.</span> : null}
        </form>
      </div>
    </section>
  );
}

export default SectionContact;
